
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../config';

export const useDownloadBatchFileMutation = ({ setsnackbarStatus }) => {

    const queryClient = useQueryClient();

    return useMutation({

        mutationFn: ({ updaterData }) => {


            return axios.post(
                `${config.API_URL}/data/downloadProformaBlobZip`,
                updaterData,
                {
                    withCredentials: true,
                    responseType:'blob'

                }

            );
        },
        onSuccess: (data, variables, context) => {
            // queryClient.invalidateQueries({ queryKey: ['PaymentListPatients'], refetchType: 'active'}, {cancelRefetch: false });
            const contentDisposition = data.headers["content-disposition"];
            const match = contentDisposition.match(/filename="?([^"]+)"?/i);
            const caseNumberArray = variables?.updaterData?.caseNumberArray.sort((a, b) => a - b);
            const fileName = match?.[1] || `RBK${caseNumberArray[0]}-RBK${caseNumberArray[caseNumberArray.length - 1]}_Proforma.zip`;



            const url = window.URL.createObjectURL(data.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);


        },
        onError: (error, variables, context) => {
            console.log(error);


            if (error?.response?.status === 406) {
                setsnackbarStatus(
                    {
                        open: true,
                        message: `Failed to Download File`,
                        severity: 'error'
                    }
                )
            } else {
                setsnackbarStatus(
                    {
                        open: true,
                        message: `Failed to Download File`,
                        severity: 'error'
                    }
                )
            }
        }
    })




}